// Zoho CRM Web-to-Lead submission via hidden-iframe form POST.
// Fire-and-forget: the iframe response is cross-origin and cannot be read,
// so success UX is driven by client-side form validation, never by this.

const ZOHO_URL = "https://crm.zoho.in/crm/WebToLeadForm";

// Fixed hidden fields required on every Zoho submission (exact values).
const HIDDEN_FIELDS = {
  xnQsjsdp: "7251809a3b6136cfa932a2eff858033c8103ddaf302cab896cb5b79ca37280e6",
  zc_gad: "",
  xmIwtLD: "8e7e6c254cc72e38430b4fed2edba06d997e8b3d52fb18915f7773d38e40d7f78d29036acfded02eca08596574816435",
  actionType: "TGVhZHM=",
  returnURL: "null",
  // Honeypot anti-spam field. Must always stay empty; never user-fillable.
  aG9uZXlwb3Q: "",
};

// Map our internal source tags to Zoho's exact Lead Source picklist values.
const LEAD_SOURCE_MAP = {
  nav_modal: "Website - Nav Button",
  hero_modal: "Website - Homepage Hero",
  investors_modal: "Website - Homepage Investors Section",
  ayodhya_modal: "Website - Ayodhya Page",
  approach_modal: "Website - Our Approach Page",
  about_modal: "Website - About Us Page",
  success_stories_cta: "Website - Success Stories Page",
  homepage_inline: "Website - Homepage Inline Form",
};

// Split a single "Name" field: first token -> First Name, remainder -> Last Name.
// No space -> whole value in Last Name, First Name blank.
function splitName(name) {
  const trimmed = (name || "").trim();
  const sp = trimmed.indexOf(" ");
  if (sp === -1) return { firstName: "", lastName: trimmed };
  return { firstName: trimmed.slice(0, sp), lastName: trimmed.slice(sp + 1).trim() };
}

// The exact Zoho Lead Source picklist value for an internal source tag.
// Used for both the Zoho POST and the GTM dataLayer push so attribution agrees.
export function zohoLeadSource(source) {
  return LEAD_SOURCE_MAP[source] || "";
}

export function postToZohoWebToLead({ name, phone, email, message, source, slot }) {
  try {
    const { firstName, lastName } = splitName(name);

    // Zoho has no time-slot field: fold the preferred call time into Description.
    const descParts = [];
    if (slot) descParts.push(`Preferred call time: ${slot}`);
    if (message) descParts.push(message);
    const description = descParts.join("\n");

    let iframe = document.getElementById("zoho-hidden-iframe");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.name = "hidden_iframe";
      iframe.id = "zoho-hidden-iframe";
      iframe.style.display = "none";
      document.body.appendChild(iframe);
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = ZOHO_URL;
    form.target = "hidden_iframe";
    form.acceptCharset = "UTF-8";
    form.autocomplete = "off";
    form.style.display = "none";

    const add = (fieldName, value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = fieldName;
      // Guard against password managers / form-fill extensions ever touching
      // the honeypot (a filled honeypot makes Zoho silently drop the lead).
      input.setAttribute("autocomplete", "off");
      input.value = value == null ? "" : value;
      form.appendChild(input);
    };

    Object.entries(HIDDEN_FIELDS).forEach(([k, v]) => add(k, v));
    add("Company", "Website Enquiry");
    add("First Name", firstName);
    add("Last Name", lastName);
    add("Phone", phone);
    add("Email", email);
    add("Description", description);
    add("Lead Source", LEAD_SOURCE_MAP[source] || "");

    document.body.appendChild(form);
    form.submit();
    setTimeout(() => form.remove(), 1500);
  } catch (e) {
    // Never block or break the visitor UX on a CRM hiccup.
    console.error("Zoho Web-to-Lead submission failed", e);
  }
}
